import { cn } from "../../lib/utils";
import { getCleanlinessLevel } from "../../logic/home-stats";
import type { CleanlinessTone } from "../../logic/home-stats";

const TONE_FILL: Record<CleanlinessTone, string> = {
  good: "bg-emerald-500 dark:bg-emerald-400",
  warn: "bg-amber-400",
  bad: "bg-red-500 dark:bg-red-400",
};

interface SegmentedProgressProps {
  /** Dirty percentage (0 = just cleaned, 100+ = overdue). */
  dirtyPercent: number;
  segments?: number;
  className?: string;
}

/**
 * Compact 3-segment cleanliness meter. More filled segments = cleaner.
 * Exposes the tier label to assistive tech.
 */
export function SegmentedProgress({
  dirtyPercent,
  segments = 3,
  className,
}: SegmentedProgressProps) {
  const level = getCleanlinessLevel(dirtyPercent);
  const filled = Math.min(level.filled, segments);
  return (
    <span
      role="img"
      aria-label={level.label}
      title={level.label}
      className={cn("inline-flex items-center gap-1", className)}
    >
      {Array.from({ length: segments }, (_, i) => (
        <span
          key={i}
          className={cn(
            "h-2 w-5 rounded-full transition-colors",
            i < filled ? TONE_FILL[level.tone] : "bg-surface-raised"
          )}
        />
      ))}
    </span>
  );
}

export default SegmentedProgress;
